/**
 * Offres du panier Santa Mode (snippet santamode-cart-offers) : bouton « Ajouter » et choix
 * de la variante. Délégation d'événements sur le document : le tiroir panier est re-rendu par
 * innerHTML à chaque mise à jour, les boutons sont donc recréés.
 *
 * La remise est appliquée par la réduction automatique Shopify de l'offre : ce script ajoute
 * seulement la variante au panier, puis rafraîchit le tiroir (ou recharge la page /cart).
 */
import { CartUpdatedEvent } from '@theme/events';

function toastError(message) {
  document.dispatchEvent(new CustomEvent('toast:open', { detail: { type: 'error', message } }));
}

document.addEventListener('change', (event) => {
  const select = event.target.closest('[data-sm-offer-variant]');
  if (!select) return;

  const card = select.closest('[data-sm-offer]');
  const option = select.selectedOptions[0];
  card.querySelector('[data-sm-offer-add]').dataset.variantId = select.value;
  card.querySelector('[data-sm-offer-price]').textContent = option.dataset.price;
  const compare = card.querySelector('[data-sm-offer-compare]');
  if (compare) compare.textContent = option.dataset.compare;
});

document.addEventListener('click', async (event) => {
  const button = event.target.closest('[data-sm-offer-add]');
  if (!button || button.disabled) return;
  event.preventDefault();

  button.disabled = true;
  button.classList.add('is-loading');

  const drawer = button.closest('cart-drawer');
  const body = { items: [{ id: Number(button.dataset.variantId), quantity: 1 }] };
  if (drawer) {
    body.sections = [drawer.dataset.sectionId, 'auto-gifts'].join(',');
    body.sections_url = window.location.pathname;
  }

  try {
    const response = await fetch(Theme.routes.cart_add_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    });
    const data = await response.json();

    if (!response.ok || data.status) {
      toastError(data.description || data.message || "Impossible d'ajouter ce produit.");
      button.disabled = false;
      button.classList.remove('is-loading');
      return;
    }

    if (drawer && data.sections) {
      document.dispatchEvent(
        new CartUpdatedEvent({}, { source: 'santamode-cart-offers', variantId: button.dataset.variantId, sections: data.sections }),
      );
    } else {
      window.location.reload();
    }
  } catch (error) {
    console.error(error);
    toastError("Impossible d'ajouter ce produit.");
    button.disabled = false;
    button.classList.remove('is-loading');
  }
});
